export const getColumnWidth = (isExtraLargeScreen: boolean, width?: number) =>
  isExtraLargeScreen ? undefined : width
